import axios from 'axios'

var qs = require('qs');
var root = window.API_ROOT


//获取列表数据
export const getListData = (params) => {
  return axios.post(root + '/set/jxcgoodsprice/list', qs.stringify(params))
}

export const copySalePrice=(params) => {
  return axios.post(root + '/set/jxcgoodsprice/copySalePrice', qs.stringify(params))
}
export const removeSalePrice=(params) => {
  return axios.post(root + '/set/jxcgoodsprice/removeSalePrice', qs.stringify(params))
}

export const getPingPaiByServer=(params) => {
  return axios.post(root + '/set/jxcgoodsprice/getPingPaiByServer', qs.stringify(params))
}


//获取产品数据，包含最新设置的价格
export const getGoodsListWithPrice = (params) => {
  return axios.post(root + '/set/jxcgoodsprice/getgoodslistwithprice', qs.stringify(params))
}

export const loadcostprice = (params) => {
  return axios.post(root + '/set/jxcgoodsprice/loadcostprice', qs.stringify(params))
}

//获取产品数据，包含最新设置的最大/最小
export const getList = (params) => {
  return axios.post(root + '/set/jxcgoodsprice/getList', qs.stringify(params))
}

//删除行
export const RemoveIndepend = (params) => {
  return axios.post(root + '/set/jxcgoodsprice/RemoveIndepend', qs.stringify(params))
}

//获取某一行的明细数据
export const getDetail = (params) => {
  return axios.get(root + '/set/jxcgoodsprice/detail', {params: params})
}
//获取某一行的明细数据
export const latestdata = (params) => {
  return axios.get(root + '/set/jxcgoodsprice/latestdata', {params: params})
}

//保存某一行的数据
export const saveData = (params) => {

  // if (params.unitguid) {//修改
  //   return axios.post(root + '/set/jxcgoodsprice/update', qs.stringify(params))
    // return axios.post(root+'/set/employee/update', params,{headers:{"Content-Type":"application/json"}})

  // } else {//添加    始终新增
    return axios.post(root + '/set/jxcgoodsprice/save', qs.stringify(params))
    // return axios.post(root+'/set/jxcgoodsprice/save',  params,{headers:{"Content-Type":"application/json"}})
  // }
}

export const getPrice = (params) => {
  return axios.post(root + '/set/jxcgoodsprice/getPrice', qs.stringify(params))
}

export const getdetailapp = (params) => {
  return axios.post(root + '/set/jxcgoodsdetail/getdetailapp', qs.stringify(params))
}

//获取下拉框、单选按钮的绑定数据
export const getControlData = (params) => {
  return axios.post(root + '/set/jxcgoodsprice/getcontroldata', qs.stringify(params))
}

//获取产品类型树
export const getGoodsTree = (params) => {
  return axios.post(root + '/set/jxcgoodsprice/tree', qs.stringify(params))
}


//导入成本价
export const uploadCostPrice = (params) => {
  return axios.post(root + '/set/jxcgoodsprice/uploadCostPrice', params,{headers:{"Content-Type":"application/json"}})
}

//导入销售价
export const uploadSalePrice = (params) => {
  return axios.post(root + '/set/jxcgoodsprice/uploadSalePrice', params,{headers:{"Content-Type":"application/json"}})
}

//导入单个账套的销售价
export const uploadSingleSalePrice = (params) => {
  return axios.post(root + '/set/jxcgoodsprice/uploadSingleSalePrice', params,{headers:{"Content-Type":"application/json"}})
}

export const simpleSave = (params) => {
  if(params.unitguid){
    return axios.post(root + '/set/jxcgoodsprice/update', qs.stringify(params))
  }else {
    return axios.post(root + '/set/jxcgoodsprice/simpleSave', qs.stringify(params))
  }

}

export const getDetailBySeedcode = (params) => {
  return axios.post(root + '/set/jxcgoodsprice/getDetailBySeedcode', qs.stringify(params))
}

export const customerseedcodelist = (params) => {
  return axios.post(root + '/set/jxcgoodsprice/customerseedcodelist', qs.stringify(params))
}




// WEBPACK FOOTER //
// ./src/api/set/goodsprice.js